module.exports = __webpack_public_path__ + "assets/assets/images/instructions/request.3d9e69e3.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/instructions/request.svg
// module id = 239
// module chunks = 0